
/* =============================================================================
DB:       Realtime DB
PURPOSE:  Stores commitment sessions
============================================================================= */

export default {
  VALID_CHECKLIST_ITEM_STATES: ['completed', 'incomplete'],

  create({ userId }, data, BACKEND) {
    return {
      commitmentId:       data.commitmentId,
      from:               data.from,       // in seconds
      to:                 data.to,
      tasks:              data.tasks || null,
      sequenceItems:      data.sequenceItems || null
    }
  },

  fields: {
    commitmentId: {},
    from: { validate_bolt_type: 'Timestamp' },
    to: { validate_bolt_type: 'Timestamp' },
    tasks: {},
    sequenceItems: {}
  }
};
